import { render, staticRenderFns } from "./liveEdit.vue?vue&type=template&id=5504c88b"
import script from "./liveEdit.vue?vue&type=script&lang=js"
export * from "./liveEdit.vue?vue&type=script&lang=js"
import style0 from "./liveEdit.vue?vue&type=style&index=0&id=5504c88b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports